import { Client_Event_Name, Host_Event_Name, } from '@quiz-buzz/common'
import {useForm} from 'react-hook-form'
import {page_header_style, Standard_Page_Layout, sub_header_style} from '../Components/Standard_Page_Layout'
import { style } from 'typestyle'
import { Button, button_input_attach_style, input_button_attached_style } from '../Components/Button'
import { header_over_form_style } from '../App/style/Headers'
import { validation_error_style, validation_warn_style } from '../App/style/Forms'
import { host_machine_actor } from '../App/main'

type FormValues = {
	host_nickname: string
}

export function Host_Trial_Registration() {

	const {
		register,
		handleSubmit,
		formState: {errors}
	} = useForm<FormValues>({
		defaultValues: {
		}
	})

	const onSubmit = handleSubmit(data =>
		host_machine_actor.send({ type: Host_Event_Name.register_trial_host, detail: { ...data, is_trial: true }})
	)

	const header = (
		<>
			<div className={page_header_style}>Create game</div>
			<div className={sub_header_style}>let&apos;s get you started</div>
		</>
	)
	const content = (
		<>
			<div className={header_over_form_style}>
				<div className="h2"><label htmlFor="host_nickname">Please enter your name</label></div>
			</div>
			<form id="host_reg_form" className={host_reg_form_style} onSubmit={onSubmit}>
				<input
					id="host_nickname"
					type="text"
					data-help-tip="intro"
					className={input_button_attached_style + ' ' + (errors.host_nickname ? validation_warn_style : '')}
					{...register('host_nickname', {
						required: {
							value: true,
							message: 'you need a name!',
						},
						maxLength: {value: 100, message: 'too long'},
						minLength: {value: 3, message: 'too short'},
					})}
					placeholder="nickname"
				/>
				<button className={button_input_attach_style} type="submit">&gt;</button>
				{errors.host_nickname ? <div className={validation_error_style}>
					{errors.host_nickname?.message}
				</div> : ''}
			</form>
			<div className={full_game_info_style}>
				Optional:
				<Button text="Full game" onClick={() => host_machine_actor.send({ type: Host_Event_Name.purchase_full_game })} />
				<div>
					No subscriptions, just buy a game and play, here's what you get:
					<ul>
						<li>Unlimited game time</li>
						<li>All the features!</li>
						<li>Save and resume</li>
						<li>Import your own questions</li>
						<li>Picture rounds</li>
						<li>Multiple choice</li>
					</ul>
				</div>
			</div>
		</>
	)

	const controls = (
		<div className="two_buttons">
			<Button text="Cancel" button_style="Danger" onClick={() => host_machine_actor.send({ type: Client_Event_Name.navigate_back })} />
			<Button text="Start setup" button_style="Primary" type="submit" form="host_reg_form" />
		</div>
	)
	return (
		<Standard_Page_Layout
			header={header}
			content={content}
			controls={controls}
		/>
	)
}

const host_reg_form_style = style({
	margin: '0 auto',
	flex: 1,
})

const full_game_info_style = style({
	border: '0.25em solid black',
	borderRadius: '0.5em',
	width: '100%',
	padding: '0.5em',
	backgroundColor: 'white',
	marginBottom: '2em',
	
})

